import objectSelectorMenu from 'scoreboard/components/bootslide/object-selector-menu'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import bootslideOption from 'scoreboard/components/bootslide/option.hbs'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'
import WebAddressForm from '../components/web-address-form'
import sections from 'scoreboard/components/sections'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import displayedPeriodId from 'scoreboard/components/displayed-period-id'

var AddMenu = BootslideMenu.extend({
	menu: function () {
		var menuOptions = objectSelectorMenu(this, 'relatedItems.addRelatedItem', AddMenuOption.extend({
			collection: this.collection
		}))

		menuOptions.target.push({
			label: i18n.get('relatedItems.webAddress'),
			content: function () {
				return $('<div></div>').append(
					bootslideOption({icon: 'web-address', label: 'relatedItems.webAddress'}))
			},
			contentEndpoint: function () {
				var v = new WebAddressForm({
					header: this.model.isNew() ? undefined : i18n.get('relatedItems.webAddress'),
					primaryButtonLabel: i18n.get(this.model.isNew() ? 'common.add' : 'common.save')
				})
				v.on('submit', ({label, url}) => {
					this.model.save({
						id: this.model.get('id'),
						id2: this.model.get('relatedId'),
						type2: 'web-address',
						label,
						url
					}, {
						success: model => {
							model.type = 'web-address'
							this.trigger('done')
						}
					})
				})

				this.childViews.push(v)

				v.on('cancel', this.back.bind(this))

				return v.render().el
			}.bind(this)
		})

		return menuOptions
	}
})

var AddMenuOption = AddDomainObjectEndpoint.extend({
	selectorOptions: function(opt) {
		return {
			orgId: this.model.get('organizationId1'),
			projectId: this.model.get('projectId1'),
			section: this.section,
			datasetsOnly: false
		}
	},

	add: function (node) {
		var duplicate = this.collection.find(function (item) {
			return item.get('relatedId') === node.id && item.get('type') === sections.toType(this.section)
		}.bind(this))

		this.treeActions.applyCheckmark()

		if (duplicate) {
			return
		}

		this.model.save({
			id2: node.id,
			type2: sections.toType(this.section),
			subtype2: (this.section === 'scorecards' || this.section === 'initiatives') ? node.type : null,
			organization: this.objectSelector.selectedOrg(),
			label: node.label,
			calendarPeriodId: displayedPeriodId()
		})
	}
})

export default AddMenu

AddMenu.__filename__ = 'related-items/add-menu.js'
